<template>
  <div class="LogOut">
    <!-- 表单搜索 start -->
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="from"
      @Refresh="Refresh"
      @search="search"
    >
      <template v-slot:left>
        <el-button @click="add(false)" type="primary">新增</el-button>
      </template>
    </Filtersearch>
    <!-- 表单搜索 end -->

    <div class="auto-table-flex">
      <el-table
        :data="tableData"
        height="100%"
        v-loading="loading"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
        ref="multipleTable"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column prop="fullname" align="center" label="客户名称">
        </el-table-column>
        <el-table-column prop="member_type_txt" align="center" label="客户类型">
        </el-table-column>
        <el-table-column
          prop="logistics_name"
          align="center"
          label="注销前所在仓"
        >
        </el-table-column>
        <el-table-column prop="mobile" align="center" label="注销前客户手机号">
        </el-table-column>
        <el-table-column prop="register_time" align="center" label="注册时间">
        </el-table-column>
        <el-table-column prop="days" align="center" label="注册天数">
        </el-table-column>
        <el-table-column prop="logout_time" align="center" label="注销时间">
        </el-table-column>
        <el-table-column prop="reason" align="center" label="注销原因">
        </el-table-column>
        <el-table-column prop="pic" align="center" label="注销证明">
          <template slot-scope="scope">
            <el-button type="text" @click="imagelist(scope.row)"
              >点击查看</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="submit_name" align="center" label="操作人">
        </el-table-column>
        <el-table-column prop="op_name" align="center" label="审核人">
        </el-table-column>
        <el-table-column prop="audit_time" align="center" label="审核时间">
        </el-table-column>
        <el-table-column
          prop="black_status_txt"
          align="center"
          label="注销状态"
        >
        </el-table-column>
        <el-table-column prop="order_no" align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" v-if="is_audit&&scope.row.audit_status==1" @click="Cancel(scope.row)"
              >审核</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="from.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="60%"
      center
    >
      <div style="height: 500px; overflow-y: auto">
        <el-image
          v-for="url in delete_info_pic"
          :key="url"
          :src="url"
        ></el-image>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <LogOutadd ref="LogOutaddref" @Refresh="Refresh"></LogOutadd>
  </div>
</template>
<script>
import Filtersearch from "@/components/Filtersearch.vue";
import LogOutadd from "./LogOutadd.vue";
export default {
  name: "LogOut",
  components: { Filtersearch, LogOutadd },
  data() {
    return {
      //列表新建页面初始参数
      loading: false,
      centerDialogVisible: false,
      from: {
        fullname: "", //	string	客户名称
        start_time: "", //	string	注销时间 开始
        end_time: "", //	string	注销时间 结束
        submit_name: "", //	string	操作人
        mobile: "", //	string	手机号
        logistics_id: "", //	number	城市仓
        page: 1,
        pageSize: 50,
      },
      is_audit: false,
      delete_info_pic: [],
      Filtersearchlist: [
        {
          type: "input",
          name: "客户名称",
          clearable: true,
          model: "fullname",
          placeholder: "请输入客户名称",
        },
        {
          type: "daterange",
          name: "注销时间",
          clearable: true,
          model: "offline_time",
          startmodel: "start_time",
          endmodel: "end_time",
          startplaceholder: "开始时间",
          endplaceholder: "结束时间",
        },
        {
          type: "input",
          name: "操作人",
          clearable: true,
          model: "submit_name",
          placeholder: "请输入操作人",
        },
        {
          type: "input",
          name: "手机号",
          clearable: true,
          model: "mobile",
          placeholder: "请输入手机号",
        },
        {
          type: "select",
          name: "城市仓",
          clearable: true,
          filterable: true,
          multiple: false,
          model: "logistics_id",
          placeholder: "请选择城市仓",
          selectoptionname: "logisticsList",
          label: "name",
          value: "id",
          selectoption: [],
        },
      ],
      tableData: [],
      currentPage: 1,
      total: 0,
    };
  },
  created() {
    this.hqlist();
    this.citylist();
  },
  methods: {
    // 城市仓列表
    citylist() {
      this.$api.general
        .logisticsList({
          name: "",
          page: 1,
          pageSize: 10000000,
        })
        .then((res) => {
          this.Filtersearchlist.forEach((el) => {
            if (el.selectoptionname && el.selectoptionname == "logisticsList") {
              el.selectoption = [...res.data];
            }
          });
        });
    },
    add(e) {
      this.$refs.LogOutaddref.hqinfo("新增注销账户");
    },
    Cancel(e) {
      this.$confirm("确定要注销吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$api.member
            .deleteaudit({
              id: e.id,
            })
            .then((res) => {
              this.$message({
                type: "success",
                message: "已注销",
              });
              this.hqlist();
            });
        })
        .catch(() => {});
    },
    imagelist(e) {
      this.centerDialogVisible = true;
      this.delete_info_pic = e.pic.split(",");
      console.log(this.delete_info_pic, "111");
    },
    hqlist() {
      this.loading = true;
      this.$api.member
        .deletelist(this.from)
        .then((res) => {
          this.loading = false;
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.is_audit = res.data.is_audit;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    search(e) {
      this.from = e;
      this.from.page = 1;
      // this.from1 = JSON.parse(JSON.stringify(this.from));
      this.currentPage = 1;
      this.hqlist();
    },
    addclick() {
      console.log("新增");
    },

    Refresh() {
      Object.assign(this.$data.from, this.$options.data().from);
      this.currentPage = 1;
      this.hqlist();
    },
    handleSizeChange(val) {
      this.from.pageSize = val;
      this.hqlist();
    },
    handleCurrentChange(val) {
      this.from.page = val;
      this.currentPage = val;
      this.hqlist();
    },
  },
};
</script>
<style lang="scss">
.LogOut {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  //   background: #ffffff;
  padding: 10px;

  .title {
    background: #ffffff;
    padding: 10px 15px;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;

    .seach {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;

      .inputs {
        // width: 207px;
        margin-right: 8px;
      }

      .multiple-select {
        width: 250px;
      }
    }

    .bjsearch {
      background: #333333;
      border-color: #333333;
    }
  }

  .auto-table-flex {
    flex-grow: 1;
    overflow-y: hidden;
  }

  .fy {
    // background-color: #000;
    box-sizing: border-box;
    padding: 10px 20px;
  }
}
</style>
